<template>
    <div>
        <div v-if="$store.hasRight('CYCLIC_ONWARD_ROUTE') || route.numbers.length > 1" class="form-label">
            <table id="route_numbers">
                <thead>
                    <tr>
                        <th>{{ $t('OUTBOUND_NUMBER') }}</th>
                        <th>{{ $t('Ringing Timeout (secs)') }}</th>
                        <th v-if="editing && $store.hasRight('CYCLIC_ONWARD_ROUTE')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(number, index) in route.numbers">
                        <td>
                            <cic-textbox
                                :maxlength="255"
                                :enabled="editing"
                                :value="number"
                                @input="(val) => updateNumber(index, val)"
                            />
                        </td>
                        <td>
                            <cic-textbox
                                :maxlength="3"
                                :enabled="editing"
                                :value="route.ringingTimeouts[index]"
                                int-only
                                @input="(val) => updateTimeout(index, val)"
                            />
                        </td>
                        <td v-if="editing && $store.hasRight('CYCLIC_ONWARD_ROUTE')">
                            <icon-button
                                v-if="route.numbers.length > 1"
                                icon="remove-icon"
                                @click="removeNumber(index)"
                            />
                        </td>
                    </tr>
                    <tr v-if="editing && $store.hasRight('CYCLIC_ONWARD_ROUTE')">
                        <td colSpan="2"></td>
                        <td>
                            <icon-button icon="add-icon" @click="addNumber" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ul v-else>
            <li class="form-label">{{ $t('OUTBOUND_NUMBER') }}</li>
            <li>
                <cic-textbox
                    id="route_number"
                    :maxlength="255"
                    :enabled="editing"
                    :value="route.numbers[0]"
                    @input="(val) => updateNumber(0, val)"
                />
            </li>
            <li class="form-label">{{ $t('Ringing Timeout (secs)') }}</li>
            <li>
                <cic-textbox
                    id="route_timeout"
                    :maxlength="3"
                    :enabled="editing"
                    :value="route.ringingTimeouts[0]"
                    int-only
                    @input="(val) => updateTimeout(0, val)"
                />
            </li>
        </ul>
    </div>
</template>

<script>
    import IconButton from '@/components/controls/IconButton';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'OnwardRoute',
        components: {
            CicTextbox,
            IconButton,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
        },
        emits: ['change'],
        methods: {
            addNumber() {
                const numbers = [...this.route.numbers];
                const timeouts = [...this.route.ringingTimeouts];
                numbers.push('');
                timeouts.push(30);
                this.updateFieldValue('numbers', numbers);
                this.$nextTick(() => {
                    this.updateFieldValue('ringingTimeouts', timeouts);
                });
            },
            removeNumber(index) {
                const numbers = [...this.route.numbers];
                const timeouts = [...this.route.ringingTimeouts];
                numbers.splice(index, 1);
                timeouts.splice(index, 1);
                this.updateFieldValue('numbers', numbers);
                this.$nextTick(() => {
                    this.updateFieldValue('ringingTimeouts', timeouts);
                });
            },
            updateNumber(index, val) {
                const numbers = [...this.route.numbers];
                numbers[index] = val;
                this.updateFieldValue('numbers', numbers);
            },
            updateTimeout(index, val) {
                const timeouts = [...this.route.ringingTimeouts];
                timeouts[index] = val;
                this.updateFieldValue('ringingTimeouts', timeouts);
            },
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
